import { _axios } from '../plugins/axios'
import { globals } from '../main.js'
import Configuration from '@/configuration'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, send an interactive request.
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}
export default {
  async save(mocId, comment = {}) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: {
            mocId: mocId,
            ...comment
          },
          url: Configuration.value('uiEndPoint').concat(`/api/Comment/${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async get(mocId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          url: Configuration.value('uiEndPoint').concat(`/api/Comment?mocId=${mocId}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  }
}
